import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CandidatePipelinePage from "@/pages/admin/CandidatePipelinePage";

export const Route = createFileRoute("/_admin/admin/candidate-pipeline")({
  head: () => pageHead("Admin · Candidate Pipeline", "AKIVA admin · candidate pipeline portal.", "/admin/candidate-pipeline", true),
  component: CandidatePipelinePage,
});
